type PlainButtonProps = {
  buttonAction?: () => void;
  children?: React.ReactNode;
  styleClass?: Object;
  disabled?: any;
};

export default function PlainButton({
  buttonAction = (a?: any) => {},
  children,
  styleClass = {
    boxShadow: '0px 0.5px 2.5px 0px rgba(0, 0, 0, 0.3)'
  }
}: PlainButtonProps) {
  return (
    <button
      type="button"
      className={`btn btn-outline-secondary whiteButton h7_400 m-1`}
      style={{
        borderRadius: '4px',
        border: 'none',
        padding: '8px',
        fontSize: '12px',
        color: 'var(--uni_std_clr)',
        // boxShadow: '0px 0.5px 2.5px 0px rgba(0, 0, 0, 0.3)',
        ...styleClass
      }}
      onClick={buttonAction}>
      {children}
    </button>
  );
}

export function UnileverButton({
  buttonAction = () => {},
  children,
  styleClass = '',
  disabled = false
}: PlainButtonProps) {
  return (
    <button
      disabled={disabled}
      className={`btn blueButton `}
      type="submit"
      style={{ padding: '8px', borderRadius: '4px', fontSize: '12px', ...styleClass }}
      onClick={buttonAction}>
      {children}
    </button>
  );
}
